// Import necessary libraries and components
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom"; // used for navigation and links
import { useAuth } from "./AuthContext";              // custom hook to get user info and logout
import LoginModal from "./LoginModal";                // modal popup for login form



function Layout({ children }) {
  // Destructure user and logout function from the authentication context
  const [isLoggingOut, setIsLoggingOut] = useState(false);
 
  const { user, logout } = useAuth();

  const [isModalOpen, setIsModalOpen] = useState(false);
  

const openModal = () => setIsModalOpen(true);
const closeModal = () => setIsModalOpen(false);


  // Manage whether the login modal is open
  const [showLogin, setShowLogin] = useState(false);

  // Hook for programmatically navigating to a different route
  const navigate = useNavigate();

  // Handle logout button click
  const handleLogout = async () => {
    setIsLoggingOut(true); // Show "Logging out..." screen
  
    // Wait for a few seconds (e.g. 2 seconds)
    setTimeout(async () => {
      await logout();        // Sign out user
      // Optional: navigate("/") here if not handled elsewhere
    }, 1000); // 2000 milliseconds = 2 seconds
  };
  
if (isLoggingOut) {
  return (
    <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      fontSize: "1.5rem",
      fontWeight: "bold",
      backgroundColor: "#fffbe6"
    }}>
      Logging out...
    </div>
  );
}
if (isLoggingOut) {
    return (
      <div style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: "100vh",
        fontSize: "1.5rem",
        fontWeight: "bold",
        backgroundColor: "#fffbe6"
      }}>
        Logging out...
      </div>
    );
  }
  

  return (
    <div>
      {/* NAVIGATION BAR */}
      <nav style={styles.navbar}>
        {/* LEFT SIDE: Logo and links */}
        <div style={styles.leftNav}>
          {/* Website logo or name */}
          <img
  src={require("./assets/Ryan Tutors Logo2.png")}
  alt="Ryan Tutors Logo"
  className="logo-image"
/>


          {/* Navigation links (e.g. Home, About) */}
          <div style={styles.links}>
            <Link to="/" className="nav-link">Home</Link>
            <Link to="/about" className="nav-link">About</Link>
          </div>
        </div>

     
      </nav>

      {/* Show the login modal popup if showLogin is true */}
      {showLogin && <LoginModal onClose={() => setShowLogin(false)} />}

      {/* Main content area for the current page */}
      <main>{children}</main>
    </div>
  );
}

// STYLES OBJECT for inline styling

const styles = {
logoImage: {
  height: "80px",
  objectFit: "contain",
  "@media (max-width: 600px)": {
    display: "none",
  },
},

      link: {
        color: "#333",  // Normal color for the link
        textDecoration: "none",
        padding: "0.5rem 1rem",
        fontFamily: "'Poppins', sans-serif",
        fontWeight: "500",
        transition: "color 0.3s ease", // For smooth color transition
      },
      linkHover: {
        color: "#a0522d",  // Brown color when hovering
      },
     
  navbar: {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  flexWrap: "wrap",         // allows wrapping if needed
  padding: "0.4rem 1rem",
  backgroundColor: "#fff3e3",
  borderBottom: "1px solid #ccc",
  position: "sticky",
  top: 0,
  zIndex: 1000,
},

  leftNav: {
  display: "flex",
  alignItems: "center",
  gap: "1rem",              // was 2rem
  flexShrink: 1,            // allow shrink
},

  logo: {
    fontSize: "1.4rem",
    fontWeight: "bold",
    color: "#2c3e50",                           // dark blue/grey
    fontFamily: "'Segoe UI', sans-serif",      // clean professional font
  },
 links: {
  display: "flex",
  gap: "0.8rem",            // was 1.5rem
  flexWrap: "wrap",
},
  link: {
    textDecoration: "none",                    // remove underline
    color: "#2c3e50",                          // text color
    fontWeight: 500,
    fontSize: "1rem",
    fontFamily: "'Segoe UI', sans-serif",
    transition: "0.2s",                        // smooth hover effect
  },
  rightNav: {
    display: "flex",
    gap: "1rem",
  },
  loginBtn: {
    padding: "0.5rem 1rem",
    border: "2px solid green",
    borderRadius: "8px",
    backgroundColor: "#f2f2f2",
    color: "green",
    fontWeight: "bold",
    cursor: "pointer",
    boxShadow: "0 4px 6px rgba(0, 128, 0, 0.2)",
    transition: "0.2s",
  },
  logoutBtn: {
    padding: "0.5rem 1rem",
    backgroundColor: "#962c2c",       // red background
    border: "none",
    borderRadius: "8px",
    color: "white",
    fontWeight: "bold",
    cursor: "pointer",
    transition: "0.2s",
  },
};

export default Layout;
